// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/cloud-upload.js';

import { paths } from '../generated/cloud-upload';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('cloud-upload', Original, paths);
